import App from '@/models/App'

export default class OrderingOrdererOrderComment extends App {
    static get entity() {
        return 'OrderingOrdererOrderComments'
    }

    static all() {
        return this.query().with('orderingAccount').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderId: this.attr(''),
            orderingAccountId: this.attr(''),
            comment: this.attr(''),
            isMine: this.attr(false),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingAccount: this.attr({}), // FIXME
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, orderingOrderId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/comments`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, orderingOrderId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/comments`,
                    App.patch(params),
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(
                orderingShipId,
                orderingOrderId,
                orderingOrderCommentId,
                params
            ) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/comments/${orderingOrderCommentId}`,
                    App.patch(params),
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingOrderId, orderingOrderCommentId) {
                return this.delete(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/comments/${orderingOrderCommentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingOrderCommentId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
